import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { LINE_ITEM_SALES_TAX, propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

/**
 * Provider-only informational line: the sales tax charged to the buyer.
 *
 * The buyer's sales-tax line is customer-scoped, so it is filtered out of the
 * provider breakdown. This surfaces the amount (from the full, unfiltered line
 * items) so the seller can see what tax was collected from the buyer and
 * remitted on their behalf. It does not affect the seller's payout.
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.lineItem>} props.allLineItems - Unfiltered transaction line items.
 * @param {boolean} props.isProvider - Whether the current viewer is the seller.
 * @param {intlShape} props.intl - The intl object.
 * @returns {JSX.Element|null}
 */
const LineItemBuyerSalesTaxInfoMaybe = props => {
  const { allLineItems, isProvider, marketplaceName, intl } = props;
  if (!isProvider) return null;

  const buyerTaxLineItem = allLineItems.find(
    item => item.code === LINE_ITEM_SALES_TAX && !item.reversal
  );
  if (!buyerTaxLineItem) return null;

  return (
    <>
      <div className={css.lineItem}>
        <span className={css.itemLabel}>
          <FormattedMessage id="OrderBreakdown.buyerSalesTaxInfo" />
        </span>
        <span className={css.itemValue}>{formatMoney(intl, buyerTaxLineItem.lineTotal)}</span>
      </div>
      <span className={css.feeInfo}>
        <FormattedMessage id="OrderBreakdown.buyerSalesTaxRemittedNote" values={{ marketplaceName }} />
      </span>
    </>
  );
};

export default LineItemBuyerSalesTaxInfoMaybe;
